<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="countries"
            autocomplete
        ></v-autocomplete>

        <h5>{{country}}</h5>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a country ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-country-key',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                countries: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getCountries();
        },

        methods: {
            getCountries:function(){
                axios.get('/api/selectable-countries')
                .then(function(response){
                    var countries = [];
                    response.data.countries.forEach(function(record){
                        countries.push({ text: record.country_name, value: record.country_key });
                    });
                    this.countries = countries;
                }.bind(this));
            },
        },

        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
